/* eslint-disable react/prop-types */
import React, { useState, Fragment, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Constants from '@Apis/constants';
import PropTypes from 'prop-types';
import {
  Button, Checkbox,
} from 'antd';
import {
  DownloadOutlined, LoadingOutlined,
} from '@ant-design/icons';
import './style.scss';
import Joi from 'joi';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3FormInput from '@Uilib/h3FormInput';
import BusyIntegrationActions from '../../../../../../../actions/integrations/busyIntegrationAction';
import BusyTabLoading from '../../BusyTabLoading';

const InstallBusy = ({
  user, connectToBusyLoading, history, connectToBusy, getBusyConnectionsLoading,
  busyConnections, integrationBusyId, isCreateFlow, connectToBusyLocation, setStep,
  connectToBusyLocationLoading,
}) => {
  const defaultBusyServerURL = 'https://127.0.0.1:981';
  const defaultState = Joi.object({
    integration_busy_id: Joi.number(),
    app_token: Joi.string().default(''),
    company_name: Joi.string().default(''),
    busy_server_url: Joi.string().default(defaultBusyServerURL),
    busy_username: Joi.string().default(''),
    busy_password: Joi.string().default(''),
  });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [getBusyHasAuthentication, setBusyHasAuthentication] = useState(false);
  const [selectedBusyConnection, setSelectedBusyConnection] = useState(null);

  useEffect(() => {
    if (isCreateFlow && selectedBusyConnection === null) {
      const _tmp = global.joiValidate(defaultState, {});
      setSelectedBusyConnection(_tmp);
    }
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      if (selectedBusyConnection === null) {
        // Since busyConnection is derived from busyConnections, ensure it's defined within this async block.
        const busyConnection = (busyConnections || []).find((i) => i.integration_busy_id == integrationBusyId);
        if (!busyConnection) {
          return;
        }
        // Perform your async operations here
        const _tmp = await global.joiValidate(defaultState, busyConnection);
        setSelectedBusyConnection(_tmp);
        if (_tmp.busy_username || _tmp.busy_password) {
          setBusyHasAuthentication(true);
        }
      }
    };

    fetchData();
  }, [busyConnections, integrationBusyId, selectedBusyConnection]);
  if (!selectedBusyConnection || getBusyConnectionsLoading) return <BusyTabLoading />;
  return (
    <Fragment>
      <div className="create-busy__wrapper">
        <div className="create-busy__spacing">
          <header className="create-busy__intro">You are required to install Busy plugin in the desktop in which your Busy application is running. Once the plugin is installed, copy the connection token and paste it below to start the activation process.</header>

          <div className="create-busy-btn__download">
            <Button
              type="primary"
              onClick={() => {
                window.location.href = `${Constants.CDN_URL}downloads/procuzy-connect-Setup-0.4.0.exe`;
              }}
              icon={<DownloadOutlined />}
              disabled={connectToBusyLoading}
            >
              Download Plugin
            </Button>
          </div>

          <div className="create-busy-input__wrapper">
            <p className="create-busy-input__label">
              Enter Connection Token
              {' '}
              <span className="color-red">
                *
              </span>
              {' '}
            </p>
            <H3FormInput
              name="Enter Token"
              type="text"
              containerClassName="orgInputContainer create__right-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder="eg. 6u86shah-wesbhdqf-673nlaufe7c"
              onChange={(value) => {
                global.setStateJSON(setSelectedBusyConnection, 'app_token', value.target.value);
              }}
              disabled={connectToBusyLoading || connectToBusyLocationLoading}
              value={selectedBusyConnection?.app_token}
              maxlength="100"
              required
              showError={formSubmitted && !selectedBusyConnection?.app_token}
            />
            <p className="create-busy-input__label">
              Enter Company Name
              {' '}
              <span className="color-red">
                *
              </span>
              {' '}
            </p>
            <H3FormInput
              name="Enter Company"
              type="text"
              containerClassName="orgInputContainer create__right-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder="eg. Moraabh Ventures Private Limited"
              onChange={(value) => {
                global.setStateJSON(setSelectedBusyConnection, 'company_name', value.target.value);
              }}
              disabled={connectToBusyLoading || connectToBusyLocationLoading}
              value={selectedBusyConnection?.company_name}
              maxlength="100"
              required
              showError={formSubmitted && !selectedBusyConnection?.company_name}
            />
            <p className="create-busy-input__label">
              Busy Server URL
              {' '}
              <span className="color-red">
                *
              </span>
              {' '}
            </p>
            <H3FormInput
              name="Enter Busy Server URL"
              type="text"
              containerClassName="orgInputContainer create__right-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder={`eg. ${defaultBusyServerURL}`}
              onChange={(value) => {
                global.setStateJSON(setSelectedBusyConnection, 'busy_server_url', value.target.value);
              }}
              disabled={connectToBusyLoading || connectToBusyLocationLoading}
              value={selectedBusyConnection?.busy_server_url}
              maxlength="100"
              required
              showError={formSubmitted && !selectedBusyConnection?.busy_server_url}
            />
            <br />
            <Checkbox
              onChange={(i) => {
                setBusyHasAuthentication(i.target.checked);
                if (i.target.checked === false) {
                  global.setStateJSON(setSelectedBusyConnection, 'busy_username', '');
                  global.setStateJSON(setSelectedBusyConnection, 'busy_password', '');
                }
              }}
              checked={getBusyHasAuthentication}
            >
              {' '}
              I have authentication in my Busy account

            </Checkbox>
            {getBusyHasAuthentication && (
              <React.Fragment>
                <p className="create-busy-input__label">
                  Busy Username
                  {' '}
                  <span className="color-red">
                    *
                  </span>
                  {' '}
                </p>
                <H3FormInput
                  name="Busy Username"
                  type="text"
                  containerClassName="orgInputContainer"
                  labelClassName="orgFormLabel"
                  inputClassName="orgFormInput"
                  placeholder=""
                  onChange={(value) => {
                    global.setStateJSON(setSelectedBusyConnection, 'busy_username', value.target.value);
                  }}
                  disabled={!getBusyHasAuthentication || connectToBusyLoading || connectToBusyLocationLoading}
                  value={selectedBusyConnection.busy_username}
                  maxlength="100"
                  required
                  showError={formSubmitted && !selectedBusyConnection?.busy_username}
                />
                <p className="create-busy-input__label">
                  Busy Password
                  {' '}
                  <span className="color-red">
                    *
                  </span>
                  {' '}
                </p>
                {((_key) => (
                  <H3FormInput
                    name="Busy Password"
                    type="text"
                    containerClassName="orgInputContainer create__right-input"
                    labelClassName="orgFormLabel"
                    inputClassName="orgFormInput"
                    placeholder=""
                    onChange={(value) => {
                      global.setStateJSON(setSelectedBusyConnection, _key, value.target.value);
                    }}
                    disabled={!getBusyHasAuthentication || connectToBusyLoading || connectToBusyLocationLoading}
                    value={selectedBusyConnection[_key]}
                    maxlength="100"
                    required
                    showError={formSubmitted && !selectedBusyConnection[_key]}
                  />
                ))('busy_password')}
              </React.Fragment>
            )}
          </div>

          {isCreateFlow ? (
            <div className="ant-row">
              <H3Button
                text="Cancel"
                buttonType={defaultButtonTypes.BLUE_BORDERED}
                onClick={() => history.push('/admin/integration/')}
                customClass="busy__action-button"
                disabled={connectToBusyLoading || connectToBusyLocationLoading}
              />
              &nbsp;&nbsp;
              <H3Button
                text={connectToBusyLoading ? <LoadingOutlined /> : 'Connect'}
                buttonType={defaultButtonTypes.BLUE_ROUNDED}
                onClick={() => {
                  setFormSubmitted(true);
                  if (selectedBusyConnection.app_token && selectedBusyConnection.company_name && selectedBusyConnection.busy_server_url) {
                    const payload = { ...selectedBusyConnection, org_id: user?.tenant_info?.org_id };
                    connectToBusy(payload, () => {
                      history.push('/admin/integration/busy');
                    });
                  }
                }}
                customClass="busy__action-button"
                disabled={connectToBusyLoading || connectToBusyLocationLoading}
              />
            </div>
          ) : (
            <H3Button
              text={connectToBusyLocationLoading ? <LoadingOutlined /> : 'Save'}
              buttonType={defaultButtonTypes.BLUE_BORDERED}
              onClick={() => {
                setFormSubmitted(true);
                if (selectedBusyConnection.app_token
                  && selectedBusyConnection.company_name
                  && selectedBusyConnection.busy_server_url) {
                  if (getBusyHasAuthentication && (!selectedBusyConnection.busy_username || !selectedBusyConnection.busy_password)) {
                    // Do nothing
                  } else {
                    const payload = { ...selectedBusyConnection, org_id: user?.tenant_info?.org_id };
                    connectToBusyLocation(payload, () => {
                      setStep('2', selectedBusyConnection?.integration_busy_id);
                    });
                  }
                }
              }}
              customClass="busy__action-button"
              disabled={connectToBusyLoading || connectToBusyLocationLoading}
            />
          )}

        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({
  TenantReducers, UserReducers, BusyIntegrationReducers,
}) => ({
  tenants: TenantReducers.tenants,
  user: UserReducers.user,
  connectToBusyLoading: BusyIntegrationReducers.connectToBusyLoading,
  getBusyConnectionsLoading: BusyIntegrationReducers.getBusyConnectionsLoading,
  busyConnections: BusyIntegrationReducers.busyConnections,
  connectToBusyLocationLoading: BusyIntegrationReducers.connectToBusyLocationLoading,
});
const mapDispatchToProps = (dispatch) => ({
  connectToBusy: (payload, callback) => dispatch(BusyIntegrationActions.connectToBusy(payload, callback)),
  connectToBusyLocation: (payload, callback) => dispatch(BusyIntegrationActions.connectToBusyLocation(payload, callback)),
});
InstallBusy.propTypes = {
  user: PropTypes.any,
  connectToBusy: PropTypes.any,
  connectToBusyLoading: PropTypes.bool,
  history: PropTypes.any,
  getBusyConnectionsLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InstallBusy));
